import styled from '@emotion/styled';
import { spacing } from 'presentations/views/styles';
import { Role } from 'domains/models/team_user/role';
import FormPaidLink from 'presentations/views/components/molecules/FormPaidLink';

interface Props {
  texts: string[];
  role: Role;
  label?: string;
  link?: string;
}

export default function Component(props: Props) {
  if (props.texts.length === 0) return null;
  const description = props.texts.join('\n');
  return (
    <ServiceUpdate>
      <FormPaidLink
        label={props.label}
        link={props.link}
        description={description}
      />
    </ServiceUpdate>
  );
}

const ServiceUpdate = styled.div`
  margin-bottom: ${spacing(24)};
`;
